import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import de from './de.json';
import en from './en.json';

export const LANGUAGE_STORAGE_KEY = 'mz_app_language';
export function readLanguage() {
  try {
    return localStorage.getItem(LANGUAGE_STORAGE_KEY) === 'en' ? 'en' : 'de';
  } catch {
    return 'de';
  }
}

// Keep language separate from Moment's global locale: legacy timer code uses
// formatted dates as internal grouping keys.
i18n.use(initReactI18next).init({
  resources: { de: { translation: de }, en: { translation: en } },
  lng: readLanguage(),
  fallbackLng: 'de',
  keySeparator: false,
  nsSeparator: false,
  supportedLngs: ['de', 'en'],
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
});

function applyLanguage(language) {
  document.documentElement.lang = language;
  try { localStorage.setItem(LANGUAGE_STORAGE_KEY, language); } catch { /* Storage may be disabled. */ }
}
i18n.on('languageChanged', applyLanguage);
applyLanguage(i18n.language);
window.addEventListener('storage', (event) => {
  if (event.key === LANGUAGE_STORAGE_KEY) i18n.changeLanguage(event.newValue === 'en' ? 'en' : 'de');
});
export default i18n;

export function translate(key, options) { return i18n.t(key, options); }
export function getLocale() { return i18n.resolvedLanguage === "en" ? "en-GB" : "de-DE"; }
